if (!customElements.get('collection-hero-slider')) {
  class CollectionHeroSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        slider: '[data-slider]',
        prev: '[data-prev]',
        next: '[data-next]',
      };
    }

    connectedCallback() {
      this.instance = new Swiper(this.querySelector(this.selectors.slider), {
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          prevEl: this.querySelector(this.selectors.prev),
          nextEl: this.querySelector(this.selectors.next),
        },
      });
    }
  }

  customElements.define('collection-hero-slider', CollectionHeroSlider);
}
